// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import pageSolarCellCalculator from './routes/pageSolarCellCalculator';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  pageSolarCellCalculator,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// let accordionDivs = document.getElementsByClassName('hemsol-accordion');
// accordionDivs.forEach((accordionDiv) => {
//   accordionDiv.getElementsByClassName('accordion-title').forEach((accordionTitle) => {
//     accordionTitle.addEventListener('click', () => {
//       accordionDiv.classList.toggle('open');
//     });
//   });
// });
/*eslint-disable */
window.toggle_interests_form = function () {
  // document.getElementsByTagName('body')[0].classList.toggle('overflow-hidden')

  const interests_form_modal = document.getElementById('interests_form_modal');
  const interests_form_modal__overlay = document.getElementById('interests_form_modal--overlay');
  const interests_form_modal__content = document.getElementById('interests_form_modal--content');
  if (interests_form_modal.classList.contains('hidden')) {
    interests_form_modal.classList.remove('hidden')
    setTimeout(function () {

      interests_form_modal__overlay.classList.add('opacity-100')
      interests_form_modal__content.classList.add('opacity-100', 'translate-y-0', 'sm:scale-100')
    }, 100)
  } else {
    interests_form_modal__overlay.classList.remove('opacity-100')
    interests_form_modal__content.classList.remove('opacity-100', 'translate-y-0', 'sm:scale-100')
    setTimeout(function () {
      interests_form_modal.classList.add('hidden')
    }, 300)
  }
}
/*eslint-enable */



// WEBPACK FOOTER //
// ./scripts/main.js